const params = {
	state: {
		// 获取课程一级菜单
		oneCodeNo: '0701',
		// 我的班级 跳转 班级详情时携带参数
		cla: null,
		// 考试examTips页面跳转examInfo页面携带的参数
		exam: {},
		// 跳转学习中心参数
		learning: {},
	},

	// 改变state
	mutations: {
		SET_CLA(state, cla) {
			state.cla = cla;
		},
		SET_EXAM(state, exam) {
			
		},
		SET_LEARNING(state, learning){
			state.learning = learning
		}
	},

	actions: {

	}
}

export default params